import React, { Component } from 'react';
import ReactGA from 'react-ga';

import { Switch, Route, Redirect } from 'react-router-dom';

import PokemonDirectory from 'scenes/PokemonDirectory';
import PokemonSingle    from 'scenes/PokemonSingle';
import MoveDirectory    from 'scenes/MoveDirectory';
import MoveSingle       from 'scenes/MoveSingle';
import RaidDirectory    from 'scenes/RaidDirectory';

class AppBody extends Component {
  constructor(props) {
    super(props);
    this.logPageView = this.logPageView.bind(this);
  }

  logPageView() {
    ReactGA.set({ page: window.location.pathname });
    ReactGA.pageview(window.location.pathname);
  }

  render() {
    return (
      <div id="AppBody" className="AppBody  flg:1 of-y:s scrolling:t  bgc:light-pewter">
        <Switch onUpdate={this.logPageView()}>
          <Route
            exact path='/'
            component={PokemonDirectory}
          />
          <Route
            exact path='/pokemon/'
            render={() => (
              <Redirect to="/" />
            )}
          />
          <Route
            path='/pokemon/:query'
            component={PokemonSingle}
          />
          <Route
            exact path='/moves/'
            component={MoveDirectory}
          />
          <Route
            path='/moves/:query'
            component={MoveSingle}
          />
          <Route
            exact path='/raids/'
            component={RaidDirectory}
          />
          <Route render={() => (
            <Redirect to="/" />
          )} />
        </Switch> 
      </div>
    );
  }
}

export default AppBody;



// WEBPACK FOOTER //
// ./src/components/AppBody.js